<template>
  <div>
    At
    <el-select
      v-close-on-zoom
      :value="state.effect.id"
      :disabled="readonly"
      class="location-select"
      @input="(locationKey) => updateLocation(locationKey)"
    >
      <el-option
        v-for="location in availableLocations"
        :key="location.key"
        :label="location.label.en"
        :value="location.key"
      />
    </el-select>
    To
    <el-select
      v-close-on-zoom
      :value="state.effect.value"
      :placeholder="placeholder"
      :disabled="readonly"
      class="moulage-select"
      @input="(moulageKey) => updateMoulage(moulageKey)"
    >
      <el-option
        v-for="moulage in availableMoulages"
        :key="moulage.key"
        :label="moulage.label.en"
        :value="moulage.key"
      />
    </el-select>
  </div>
</template>

<script>
import flatten from 'lodash/flatten';
import uniq from 'lodash/uniq';
import keyBy from 'lodash/keyBy';

import moulages from '~lib/common/config/moulages';
import physicalAssessmentLocations from '~lib/common/config/physicalAssessmentLocations';
import structuralMoulageLocations from '~lib/common/config/structuralMoulageLocations';
import physicalToStructural from '~lib/common/config/physicalAssessmentLocationsToStructuralLocations';

export default {
  name: 'moulage-effect',
  components: {},
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
    'moulageCategory',
    'placeholder',
    'useStructuralLocations'
  ],
  data() {
    return {
      state: {
        effect: {
          id: null,
          value: null,
        },
      },
    };
  },
  computed: {
    availableMoulages() {
      if (!this.moulageCategory) {
        return moulages;
      }
      return moulages.filter((m) => m.category === this.moulageCategory);
    },
    availableLocations() {
      const availablePhysicalLocations = uniq(
        flatten(this.availableMoulages.map((moulage) => moulage.locations))
      )
        .map((locationKey) =>
          physicalAssessmentLocations.find((location) => location.key === locationKey)
        )
        .filter((physicalAssessmentLocation) => !!physicalAssessmentLocation);
      if (this.useStructuralLocations) {
        return availablePhysicalLocations
          .map(
            (physicalAssessmentLocation) =>
              physicalToStructural[physicalAssessmentLocation.key]
          )
          .map((structuralMoulageLocationKey) =>
            structuralMoulageLocations.find(
              (structuralMoulageLocation) =>
                structuralMoulageLocation.key === structuralMoulageLocationKey
            )
          )
          .filter((structuralMoulageLocation) => !!structuralMoulageLocation);
      }
      return availablePhysicalLocations;
    },
    moulagesByKey() {
      return keyBy(moulages, 'key');
    },
  },
  mounted() {
    this.state.effect = {
      ...this.state.effect,
      ...(this.getData(this.ikey) || {}),
    };
    if (!this.state.effect.id) {
      this.state.effect.id = this.availableLocations[0]
        ? this.availableLocations[0].key
        : null;
    }
    if (!this.state.effect.value) {
      this.state.effect.value = this.availableMoulages[0]
        ? this.availableMoulages[0].key
        : null;
    }
    this.emitter.trigger('process', this.control);
    this.update();
  },
  methods: {
    updateLocation(locationKey) {
      this.state.effect.id = locationKey;
      this.update();
    },
    updateMoulage(moulageKey) {
      this.state.effect.value = moulageKey;
      this.update();
    },
    update() {
      const selectedMoulage = this.moulagesByKey[this.state.effect.value];
      const type =
        selectedMoulage && selectedMoulage.isStructural
          ? 'STRUCTURAL_MOULAGE'
          : 'MOULAGE';
      this.putData(this.ikey, { ...this.state.effect, type });
      this.emitter.trigger('process', this.control);
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
</style>
